import { handBack } from '../ability/context.js';
import type { PortWithWrites } from '../port-contract.js';

/** Native dependency writers already updated the commit frame in call order.
 * A direct SQL intent needs an explicit native mapping before this port can run. */
export function nativePortValue<T>(result: PortWithWrites<T>): T {
  if (result.writes.length) handBack('k4-dispatch:unmapped-write-intent');
  return result.value;
}
